import hyperdom from 'hyperdom'
import FrequentTravellerDiscountSchema from './frequentTravellerDiscountSchema.js'
import SectionComponentBase from './sectionComponentBase.jsx'
import frequentTravellerDates from 'root-packages/dates/frequentTravellerDates.js'
import DeclarationVerificationBanner from './declarationVerificationBanner.jsx'

export default class FrequentTravellerDiscount extends SectionComponentBase  {
  constructor ({config, departure, quoteCriteria}) {
    super({sectionName: 'past-guest'})
    this.quoteCriteria = quoteCriteria
    this.config = config
    this.schema = new FrequentTravellerDiscountSchema({
      config: this.config,
      departure,
    }).buildSchema()
    this.declarationVerificationBanner = new DeclarationVerificationBanner({config})
    this.frequentTravellerMonthNames = frequentTravellerDates.monthNames
    this.frequentTravellerYears = frequentTravellerDates.years
  }

  render () {
    return <div className='past-passenger-discount'>
      <div className='o-accent-box'>
        {this.renderMobile()}
        {this.renderValidationError(this.quoteCriteria, 'frequentTravellerDiscount')}
      </div>
    </div>
  }

  removeFrequentTravellerDiscounts () {
    this.quoteCriteria.passengers.forEach((passenger) => {
      passenger.frequentTravellerDiscount = {selected: false}
    })
  }

  renderMobile () {
    if (this.quoteCriteria.passengers.some(passenger => passenger.frequentTravellerDiscount.selected)) {
      this.toggledForMobile = true
    }
    return [
      this.renderHeader(),
      this.renderRadioButtons({
        onNoClick: () => {
          this.quoteCriteria.passengers.forEach(p => delete p.frequentTravellerDiscount.selected)
        },
      }),
      this.renderPassengersList(),
      this.declarationVerificationBanner,
    ]
  }

  removeReferralPromoIfNecessary () {
    if(this.quoteCriteria.passengers.filter(p => p.frequentTravellerDiscount?.selected === true).length === this.quoteCriteria.passengers.length) {
      this.quoteCriteria.removeReferralPromo()
    }
  }

  renderHeader () {
    return [
      <p className='discounts-offers__title'>{this.config.localisedWords.ftd}
        <span className='travel-protection-tooltip tooltip'>
          <div className='tooltip__content'>If you have previously {this.config.localisedWords.travelled} with one of The Travel Corporation (TTC) brands, you may be eligible for special benefits and offers on your booking. Here are the qualifying brands: Trafalgar, Costsaver, Insight Vacations, Luxury Gold, Contiki, Brendan Vacations, AAT Kings, Inspiring Journeys.
          </div>
        </span>
      </p>,
      <p className='discounts-offers__subtitle'>{this.config.pastGuestBenefitText}</p>,
    ]
  }

  renderPassengersList () {
    return <div className={`past-passenger-discount__passengers ${this.toggledForMobile ? 'show': ''}`}>
      {this.quoteCriteria.passengers.map((passenger, index) => {
        return <div className='past-passenger-discount__passenger'>
          <div className={`past-passenger-discount__passenger-info past-passenger-discount__passenger-info-${index}`}>
            <label for={`passenger-ftd-${index}`} className='o-choice-item -fullWidth u-margin-bottom-none'>
              <input id={`passenger-ftd-${index}`} type='checkbox' className='o-choice-item__checkbox o-choice-item__checkbox-small' binding={[passenger.frequentTravellerDiscount, 'selected']} onchange={() => {this.removeReferralPromoIfNecessary()}}/>
              <div className='o-choice-item__content o-choice-item__content_small'>
                <span className={index === 0 ? 'passenger-name-semibold' : 'passenger-name'}>{passenger.fullName()}{index === 0 ? ` (Lead Passenger)` : ``}</span>
              </div>
            </label>
            <div className={['question-container',{'show-expanded': passenger.frequentTravellerDiscount.selected}]}>
              { passenger.frequentTravellerDiscount.selected
                ? [
                  <label for={`additional-tour-name-${index}`} className='additional-tour-name-label o-choice-item'>
                    Name of trip
                    <input id={`additional-tour-name-${index}`}
                      placeholder='Trip name'
                      className='ftd-tour-name-input o-form-item__txt-input u-margin-top-small'
                      binding={[passenger.frequentTravellerDiscount, 'tourName']} />
                    { this.renderValidationError(passenger.frequentTravellerDiscount, 'tourName', {cssClass: 'tourNameErrors'}) }
                  </label>,
                  <div className='u-margin-bottom-medium'>
                    <label for='tourDateMonth' className='o-choice-item'>
                      Date travelled
                    </label>
                    <select className='o-form-item__txt-input ftd-tour-date-month-input'
                      binding={[passenger.frequentTravellerDiscount, 'tourDateMonth']}
                      onchange={() => this.fieldVisited(passenger.frequentTravellerDiscount, 'tourDateMonth')}>
                      <option value='0'>Month</option>
                      { this.frequentTravellerMonthNames.map((m, i) => {
                        return <option value={i + 1}>{m}</option>
                      })
                      }
                    </select>
                    { this.renderValidationError(passenger.frequentTravellerDiscount, 'tourDateMonth', {cssClass: 'o-form-item__warning-half tourDateMonthErrors'}) }
                    <select className='o-form-item__txt-input ftd-tour-date-year-input'
                      binding={[passenger.frequentTravellerDiscount, 'tourDateYear']}
                      onchange={() => this.fieldVisited(passenger.frequentTravellerDiscount, 'tourDateYear')}>
                      <option value='0'>Year</option>
                      { this.frequentTravellerYears.map((y) => {
                        return <option value={y}>{y}</option>
                      })
                      }
                    </select>
                    { this.renderValidationError(passenger.frequentTravellerDiscount, 'tourDateYear', {cssClass: 'o-form-item__warning-half-right tourDateYearErrors'}) }
                  </div>,
                ] : undefined
              }
            </div>
          </div>
        </div>
      })}
    </div>
  }
}
